import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson20: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson19"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Market/Limit Orders
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson21"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[7.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>What Is a Limit Order?</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            A limit order is a direction given to a broker to buy or sell a
            security at a specific price or better. It is a way for traders to
            execute trades at desired prices without having to constantly
            monitor markets. It is also a way to hedge risk and ensure losses
            are minimized by capturing sale prices at certain levels.
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                A buy limit order will be executed only at the limit price or a
                lower price.
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                A sell limit order will be executed only at the limit price or a
                higher one.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The price is guaranteed, but the filling of the order is not. Limit
            orders will be executed only if the price meets the order
            qualifications.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The alternative to a limit order is a market order, which calls for
            a trade to be executed at the prevailing market price without any
            price limit specified.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>KEY TAKEAWAYS</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A limit order guarantees that an order is filled at or better
                  than a specific price level.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A limit order is not guaranteed to be filled, however.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Limit orders control execution price but can result in missed
                  opportunities in fast-moving market conditions.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Limit orders can be used in conjunction with stop orders to
                  prevent large downside losses.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  A limit order is usually valid for either a specific number of
                  days (i.e. 30 days), until the order is filled, or until the
                  trader cancels the order.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Limit Orders Work</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A limit order is placed with your broker. That limit order
                states the security, the quantity, the price, and whether you
                are in a buy or sell position. The order is not triggered until
                the specific desired market price is achieved. Even then,
                execution of the limit order is not guaranteed, especially in
                highly volatile markets or regarding highly volatile securities
                with low liquidity.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A limit order is the use of a pre-specified price to buy or sell
                a security. For example, if a trader is looking to buy XYZ’s
                stock but has a limit of $14.50, they will only buy the stock at
                a price of $14.50 or lower. If the trader is looking to sell
                shares of XYZ’s stock with a $14.50 limit, the trader will not
                sell any shares until the price is $14.50 or higher.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By using a buy limit order the investor is guaranteed to pay the
                buy limit order price or better, but it is not guaranteed that
                the order will be filled. A limit order gives a trader more
                control over the execution price of a security, especially if
                they are fearful of using a market order during periods of
                heightened volatility.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There are various times to use a limit order such as when a
                stock is rising or falling very quickly, and a trader is fearful
                of getting a bad fill from a market order. Additionally, a limit
                order can be useful if a trader is not watching a stock and has
                a specific price in mind at which they would be happy to buy or
                sell that security. Limit orders can also be left open with an
                expiration date.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Limit Order Example</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A portfolio manager wants to buy Tesla Inc's (TSLA) stock but
                  believes its current valuation at roughly $750 per share is
                  too high and would like to buy the stock should it fall to a
                  specific price. The PM instructs his traders to buy 10,000
                  shares of Tesla should the price fall below $650. The trader
                  then places an order to buy 10,000 shares with a $650 limit.
                  Should the stock fall below that price the trader can begin
                  buying the stock. The order will remain open until the stock
                  reaches the PM’s limit or the PM cancels the order.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`Additionally, the PM would like to sell `}</span>
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="http://Amazon.com"
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Amazon.com
                    </span>
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                <span>
                  {" "}
                  Inc.'s (AMZN) stock but feels its current price of roughly
                  $2,300 is too low. The PM instructs his trader to sell 5,000
                  shares should the price rise above $2,750, good until
                  cancelled. The trader will then put the order out to sell
                  5,000 shares with a $2,750 limit.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <i className="font-dm-sans">
                  Brokerage firms may not allow limit orders if they are
                  illogical (i.e. if a limit to buy is placed at greater than
                  price, Brokerage firms may also offer this service to
                  investors for free.
                </i>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Limit Orders vs. Market Orders</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When an investor places an order to buy or sell a stock, there
                are two main execution options in terms of price: place the
                order "at market" or "at limit." Market orders are transactions
                meant to execute as quickly as possible at the present or market
                price. Conversely, a limit order sets the maximum or minimum
                price at which you are willing to buy or sell.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Buying stocks can be thought of with an analogy to buying a car.
                With a car, you can pay the dealer’s sticker price and get the
                car or you can negotiate a price and refuse to finalize the deal
                unless the dealer meets your price. The stock market can be
                thought of to work in a similar way.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A market order deals with the execution of the order; the price
                of the security is secondary to the speed of completing the
                trade. Limit orders deal primarily with the price; if the
                security's value is currently resting outside of the parameters
                set in the limit order, the transaction does not occur.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                What Is the Difference Between a Limit Order and a Stop-Limit
                Order?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A limit order is an order requesting the purchase or sale of
                securities should a specific price be met. A stop-limit order
                builds one additional layer that requires a specific price be
                met that is different than the sale price. For example, a limit
                order to sell your security for $15 will likely execute when the
                market price reaches $15. Alternatively, a stop-limit order can
                be placed to sell your security for $15 only if the share price
                has dropped from $20 to $16.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Long Does a Limit Order Last?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The term of the limit order will depend on your specification
                and your broker’s policy. Many brokers default limit orders to
                day-only trades; any unfilled orders at market close are
                cancelled without execution. Other brokers may offer a specific
                number of days often in intervals of 30 (i.e. 30 days, 60 days,
                or 90 days). Last, some brokers offer limit orders that are
                considered good until filled; the limit order will remain valid
                until it is filled or deliberately cancelled by the trader.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Why Did My Limit Order Not Get Filled?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A limit order may not get filled for a few reasons. First, your
                limit order will only trigger when market pricing meet your
                desired contract amount. If a security is trading above your buy
                order or below your sell order, it will likely not fill until
                there is price action on your security.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A limit order can only fill if a security has liquidity. If the
                security does not have enough shares trading at the specific
                price you placed, your order may not fill. This is most common
                for larger orders placed on low-volume securities. Due to
                volatility, a stock on the day of its IPO may have difficulty
                filling due to rapid price fluctuation.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.56rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Trading Order Types</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  It is important for all crypto investors, regardless of your
                  level of experience, to know the basic trading order types.
                  Most cryptocurrencies can be bought or sold using three
                  trading fundamentals:
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Market Orders</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Limit Orders</span>
                </span>
              </li>
              <li>
                <span>
                  <span>Stop-loss orders</span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[42.81rem] h-[15.81rem] object-cover"
            alt=""
            src="/i78@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Market Orders - Make The Trade Now</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Out of the 3 fundamental order types, market orders are
                    probably the easiest to understand for beginner investors.
                    If you are completely new to trading it delivers the ideal
                    learning experience.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b className="font-dm-sans">Market Order</b>
                  <span>
                    {" "}
                    is an order to buy or sell an asset at the price currently
                    available on the market. It will execute the order at the
                    nearest ask price (what someone is willing to sell for) and
                    a market sell order will execute at the nearest bid price
                    (what someone is willing to buy for).
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[21.94rem] object-cover"
            alt=""
            src="/i79@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          This is the method that the vast majority of Crypto buyers utilize
          (Not necessarily Investors), to quickly purchase the currency of
          choice. When you decide to place a market order you only need to
          specify the amount of the asset you would like to buy or sell. You do
          not specify a price since the price will be decided by the best
          current rates that are available in the market.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Advantages of Market Orders</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Traders normally use market orders when they want to buy or
                  sell an asset immediately
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  This helps avoid potential loss of profit and also allows
                  traders to cut their losses
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Guarantee that a trader will enter or exit a position as
                  quickly as possible but doesn't guarantee a price
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Best used for extremely liquid assets like well-established
                  cryptocurrencies
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Usually bought and sold at traders' desired prices</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Any market orders not placed with very liquid cryptocurrencies
                  are subject to longer fulfillment time meaning the execution
                  price can be far from the trader's desired price.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Disadvantages of Market Orders</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Slippage - causes traders to pay more for a cryptocurrency
                  than intended
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  When a market order buys or sells all of the cryptocurrencies
                  available at one price, the market order will continue to buy
                  or sell the asset at the next best price (which gets
                  considerably worse)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Caution should be used when placing market orders with high
                  volume trades
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  To avoid slippage do not place orders market orders during
                  unstable periods of volatility but rather utilize limit
                  orders.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Market Order - Case Study</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Let's say you wanted to buy 100 ABC coins because you believe
                the price for it will rise soon. Since you believe the price
                will rise in the short term you do not want to miss out, so you
                decide to place a market order.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                On your respective exchange dashboard, you will select the
                market (trading pair) that you need. Your goal here in this
                example is to buy 100 ABC coins using USD. In the list of
                available trading pairs on your exchange, you select ABC/USD. On
                your Market Order tab, enter the amount of ABC you want to buy
                and place your market order.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When you place that market order, time is considered your main
                priority. So, your exchange platform will automatically match
                your market buy order (100 ABC Coins) with the best limit sell
                order in the "order book". Let's say in this case that the
                cheapest sell order is 100 ABC for 500 USD. Your order will
                execute at that price since it's the "best limit sell order"
                currently in the exchange market.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Slippage Concerns</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Let's continue with this example to understand how slippage can
                occur in this case. Let's say instead of 100 ABC coins you want
                to buy 1,000 ABC coins. Using our example above the current best
                limit sell order is only 100 ABC coins for 500 USD. That is
                clearly too small for your market order of 1,000 ABC coins.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                What will occur next is your exchange's system will match you
                with the following sell orders from the order book. In this
                case, you can pay much higher than expected per ABC coin at 10
                USD for 1 ABC. This is an example of slippage.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[7.5rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Limit Orders - Make the Trade When Price is Right</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  If you need more security and control over your trades that
                  are executed, limit orders could be a better option for you
                  depending on the types of trades you want to conduct.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  A limit order is an order to buy or sell an asset at a
                  specific price or better when possible. A buy-limit order is
                  transacted at the limit price set or lower, while a sell limit
                  order is executed at the limit price set or higher.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[43.25rem] h-[17.94rem] object-cover"
            alt=""
            src="/i80@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          However, limit orders are not guaranteed to execute. A limit order
          will only be filled if the market price of the asset reaches the limit
          price that you set. Despite limit orders not guaranteeing order
          fulfilment, they are still useful because they ensure that you do not
          pay more or receive less than a specific set price.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Advantages of Limit Orders</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  The trader gets to set their own price at which the order
                  should be fulfilled
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Ensures traders don't pay more or receive less than their
                  desired set price
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Beneficial for cryptos that are highly volatile, lightly
                  traded, or has a wide bid-ask spread.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Disadvantages of Limit Orders</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Actual market price may never reach the limit order
                    guidelines and the trader's order may fail to ever execute.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Target price may not be reached within the short term but
                    once finally reached supply/demand could be much lower than
                    when initially placed. This will result in not enough
                    liquidity to actually fill the order.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`In addition to the `}</span>
                <b className="font-dm-sans">basic limit order</b>
                <span className="font-dm-sans">
                  , there are two additional advanced types of limit orders.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Buy Stop-Limit Order</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A stop-limit order requires setting a stop price (the start of
                the target price for a trade), a limit price (the end of the
                target price of the trade), and a time period for execution.
                After the cryptocurrency reaches the set stop price, the limit
                order goes into effect, and the order is executed only when the
                asset price is at or better than the specified limit price.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Sell Stop-Limit Order</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The exact opposite of a buy stop-limit order. This is used when
                a trader wants to sell an asset after it moves below a certain
                level to minimize their risk in a trade. Unlike buy stop-limit
                orders, which are placed above market price at the time of the
                order, sell stop-limit orders are placed below market price at
                the time of the order.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Limit Order - Case Study</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Following the example for market orders, let's say this time you
                are planning to sell your 100 ABC because you need 500 USD. So,
                you place a limit order on your exchange where this coin is
                available, with the selling price of 5 USD for 1 ABC coin (500
                USD for 100 ABC). This means that unless another trader in the
                market wants to buy your coins at this price, the order will not
                execute and will stay in your wallet.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Let's say you want to buy 100 of this new token (ABC) because it
                looks very promising. However, you aren't 100% certain as its
                price has been pretty volatile the last few weeks. In this case,
                you place a limit buy order so you can purchase at a price you
                feel comfortable at.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You set the price that you want which will be 1 USD for 1 ABC.
                Then you select the exact amount you want to buy ( in this case
                100 ABC). The market price for ABC at the time your limit order
                is placed is 2 USD. Once the price drops down to 1 USD, your
                order will execute. If it never drops to 1 USD your limit order
                will never be placed.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[7.5rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Stop-Loss Order - Cover your open positions</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  With a stop-loss orders, you can instruct your trading
                  exchange platform or broker to sell your cryptocurrency if its
                  price falls below a certain amount. This is primarily used to
                  minimize unexpected losses. In the event of a sudden crypto
                  bear market, this type of order can assist in minimizing your
                  losses.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>There are two main types of stop-loss orders.</span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[43.25rem] h-[24.19rem] object-cover"
            alt=""
            src="/i90@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Stop-Loss Limit</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                With a regular stop-loss order, your trading exchange will
                automatically sell your cryptocurrencies once the price reaches
                your specified limit. With a stop-loss limit order, the system
                will automatically convert the order to a sell when your
                specified stop (or trigger) price is reached, but will only sell
                at the limit price you specified.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Trailing-Stop Order</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                For this order, you’d set the trailing amount as a percentage of
                how much you are fine with losing. A sell trailing stop order
                sets the stop price at an amount fixed below the market price
                with a trailing amount attached. As a price rises in the market,
                the stop price rises accordingly by the trailing amount. But if
                the stock price falls, then the stop-loss price wouldn't change.
                In this case, the order would convert back to a market order
                once the stop price is reached.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Stop-Loss Order - Case Study</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Let's say you buy ABC coin for $50 USD. You are unsure of the
                market's future and set a stop loss order at $45 USD just to be
                safe and minimize any potential losses in the event of a bear
                market. The next day bad news comes out about ABC coin and its
                price drops below $45 USD.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In this case, your stop-loss order will execute at the
                prevailing market price. ABC coin continues to drop to $10 USD.
                By implementing this stop-loss order you can minimize your loss
                to $5 USD ($50-$45) rather than $40 USD ($50-$10).
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Do I Know What Order Type To Use?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                All of these various order types each have their own purpose! To
                figure out the best one to use you must first assess your own
                personal situation. Are you following a play call? Or maybe you
                just want to buy into crypto to hold for the long term? Each one
                of these scenarios can affect what order type you select.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Market orders are perfect if you wish to sell or buy your assets
                immediately. Everyone wants to get the best entry/exit price but
                time ****is the priority with this type of order.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Limit orders are great if you don't mind waiting for the
                acceptable price to come up (or never come). It guarantees you
                won’t sell or buy at any other price than you desire.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Stop-loss orders are great if you have any open positions
                already and want to ensure you can minimize your losses if there
                are any sudden changes in market prices.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Useful Tips for Beginners</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>
                  Here are some key things to keep in mind when you are placing
                  buying and selling orders.
                </b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Avoid market orders if the crypto asset you want to trade
                    has been very volatile lately.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>You could end up paying much more than desired</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Market orders are perfect for buying an asset with a high
                    liquidity level.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    If you are in a rush look to use market orders. If not, look
                    into limit orders.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Market orders are nearly impossible to cancel as they get
                    filled very fast.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Market orders normally have higher fees than limit orders.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Market orders are also ideal when you are extremely
                    confident a big catalyst event will happen soon to affect
                    the price of your crypto asset either positively or
                    negatively.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    It will allow you to get in or out of a play quickly to
                    maximize gains or minimize losses.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Before clicking Buy or Sell on any order please make sure to
                    double-check the numbers.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Use an online currency converter to copy-paste the correct
                    numbers right into the order tab if you are struggling.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Keep in mind your limit order may not execute even if the
                    price reaches the mark you set.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    This can occur when there are other orders for the same
                    price, placed before yours.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Most exchanges allow you to edit your limit orders to
                    re-adjust the price to the changing market.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    They also allow for ease of cancellation if the order is NOT
                    in progress (being filled
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Be sure to check out our Crypto Trading Guide to learn more
                  about the types of trades when participating in any
                  transactions.
                </span>
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson21">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson20;
